import { render, staticRenderFns } from "./LegendLayerListIcon.vue?vue&type=template&id=555deb4c&scoped=true&"
import script from "./LegendLayerListIcon.vue?vue&type=script&lang=js&"
export * from "./LegendLayerListIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555deb4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
